import type { FunctionComponent } from 'react'
import React from 'react'

import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { CardedDynamicTableProps } from './CardedDynamicTable'
import { CardedDynamicTableWrapper } from './CardedDynamicTableWrapper'

export const CardedDynamicTableLoggedOut: FunctionComponent<CardedDynamicTableProps> = ({
  dynamicTableId = '',
  logInCTA,
  products,
  signUpCTA,
  title,
  trackingPrefix = 'spp',
}) => {
  const stackedCards = useFeatureIsOn('whc-941-stacked-cards')

  return (
    <CardedDynamicTableWrapper
      dynamicTableId={dynamicTableId}
      logInCTA={logInCTA}
      products={products}
      signUpCTA={signUpCTA}
      stackedCards={stackedCards}
      title={title}
      trackingPrefix={trackingPrefix}
    />
  )
}
